import { waitFor } from '@/common/utils';
import { i18n } from '@/plugins/i18n';

const ENABLE_CHECKS = false;
interface ApiCheck {
  id: string;
  slots: () => {
      message: string;
      actionMessage: string;
      warning: string;
  };
  check: () => Promise<boolean>;
}
const KYC: ApiCheck = {
  id: 'KYC',
  slots: () => ({
    message: i18n.t('chat.v2.check.kyc.message') as string,
    actionMessage: i18n.t('chat.v2.check.kyc.action_message') as string,
    warning: i18n.t('chat.v2.check.kyc.warning') as string,
  }),
  check: async () => {
    if (!ENABLE_CHECKS) return true;
    await waitFor(3000);
    return false;
  },
};

export const CHECKS = {
  KYC,
};
